import React from "react";
import { string } from "prop-types";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Container from "@mui/material/Container";

const AccessFlag = ({ toolName }) => {
  return (
    <Container>
      <Paper
        sx={{
          width: "100%",
          marginTop: 2,
          padding: 4,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            textAlign: "center",
            marginBottom: 2,
          }}
        >
          Your organization currently does not have access to this tool
        </Typography>
        <Button
          size="small"
          color="secondary"
          target="_blank"
          href={`mailto:analytics@icer.org?subject=Access Request: ${toolName}`}
        >
          Request Access
        </Button>
      </Paper>
    </Container>
  );
};

AccessFlag.propTypes = {
  toolName: string.isRequired,
};

export default AccessFlag;
